import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import common_en from './translations/en.json';

i18n.use(initReactI18next).init({
  debug: true,
  lng: 'en',
  resources: {
    en: {
      translation: common_en,
    },
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
